export default __webpack_public_path__ + "static/media/wegovy-drop-or-not.9240c429.mp4";